/* FREE SHIPPING — ligne livraison unifiée (web component <free-shipping>).
   Convertit le seuil dans la devise du visiteur (réutilise currencies.js officiel Shopify,
   même logique que component-stock-shipping.js). Premier-party, léger, ne tourne qu'au chargement. */
(() => {
  if (customElements.get('free-shipping')) return;

  let currencyPromise = null;
  function loadCurrencies() {
    if (window.Currency && typeof window.Currency.convert === 'function') return Promise.resolve();
    if (currencyPromise) return currencyPromise;
    currencyPromise = new Promise((resolve) => {
      const s = document.createElement('script');
      s.src = '/services/javascripts/currencies.js';
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });
    return currencyPromise;
  }

  class FreeShipping extends HTMLElement {
    connectedCallback() {
      this._convertThreshold();
    }

    _convertThreshold() {
      const amountEl = this.querySelector('[data-free-shipping-amount]');
      if (!amountEl) return;
      const thresholdCents = parseInt(this.dataset.thresholdCents, 10);
      const shopCurrency = this.dataset.shopCurrency;
      const customerCurrency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || shopCurrency;
      if (!thresholdCents || !shopCurrency || customerCurrency === shopCurrency) return;
      const locale = (window.Shopify && window.Shopify.locale) || 'fr';
      loadCurrencies().then(() => {
        if (!window.Currency || typeof window.Currency.convert !== 'function') return;
        const converted = window.Currency.convert(thresholdCents / 100, shopCurrency, customerCurrency);
        if (typeof converted !== 'number' || isNaN(converted)) return;
        try {
          amountEl.textContent = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: customerCurrency,
            maximumFractionDigits: 0,
          }).format(converted);
        } catch (e) {}
      });
    }
  }

  customElements.define('free-shipping', FreeShipping);
})();
